import { Volume1, Volume2, VolumeX } from 'lucide-react'

import { usePlayer } from '@/audio/store'
import { IconButton } from '@/components/ui'
import { cn } from '@/lib/cn'

import { RangeSlider } from './SeekBar'

export interface VolumeControlProps {
  className?: string
}

/**
 * Desktop only. Phones and tablets route volume through the hardware keys and
 * ignore `HTMLMediaElement.volume` entirely on iOS, so a slider there is a
 * control that does nothing.
 */
export function VolumeControl({ className }: VolumeControlProps) {
  const volume = usePlayer((state) => state.volume)
  const muted = usePlayer((state) => state.muted)
  const setVolume = usePlayer((state) => state.setVolume)
  const toggleMute = usePlayer((state) => state.toggleMute)

  const effective = muted ? 0 : volume
  const percent = Math.round(effective * 100)
  const Icon = percent === 0 ? VolumeX : percent < 50 ? Volume1 : Volume2

  return (
    <div className={cn('hidden items-center gap-1 md:flex', className)}>
      <IconButton
        aria-label={muted ? 'Unmute' : 'Mute'}
        aria-pressed={muted}
        size="sm"
        onClick={toggleMute}
      >
        <Icon className="h-5 w-5" aria-hidden="true" />
      </IconButton>

      <RangeSlider
        className="w-16 xl:w-24"
        value={percent}
        max={100}
        step={1}
        label="Volume"
        valueText={muted ? 'Muted' : `${percent}%`}
        onPreview={(value) => setVolume(value / 100)}
        onCommit={(value) => setVolume(value / 100)}
      />
    </div>
  )
}
